import MaterialIcon from '@components/common/MaterialIcon';
import type { ModalCommonProps } from './modal-types';

export const ModalHeader = (props: ModalCommonProps) => {
  // Destructuring props
  const {
    content = '',
    className = '',
    titleIcon = undefined,
    onClose,
    children,
    headerMargin = 'mb-6',
    titleSize = 'text-xl',
    titleColor = '!text-primary-base',
  } = props;

  // Header content; can be either from content prop or children, but not both
  const headerContent = content || children;
  return (
    <div
      className={`flex items-center justify-between ${headerMargin} ${className}`}>
      {titleIcon && (
        <MaterialIcon
          icon={titleIcon.icon}
          classes={[`text-${titleIcon.color}`, 'mr-2']}
        />
      )}
      <h3 className={`${titleSize} font-medium ${titleColor}`}>
        {headerContent}
      </h3>
      <button
        onClick={onClose}
        type='button'
        className='text-gray-500 bg-transparent hover:text-gray-800 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center focus:outline-none'
        data-modal-hide='conversed-modal'>
        <MaterialIcon icon={'close'} classes={['text-lg']} />
      </button>
    </div>
  );
};
